<template>
    <div>
        <form-container header-text="ADE, DSV, Attest" :width="400" :action="action" :valid-actions="['bestaetigungen']"
                        header-icon="mdi-card-account-details"
                        @save="save()" v-if="!$store.state.local.loader">
            <v-card-text v-if="actionObject &&
                    (!actionObject.spieler.passNr || actionObject.spieler.passNr==='ummeldung')" class="px-6">
                Für Mitglied <span class="font-weight-bold primary--text">{{actionObject.spieler.vorname}}
            {{actionObject.spieler.nachname}}</span> gibt es leider keinen Pass, der aktuell gültig ist.<br>
                Bitte warte bis der Pass erstellt ist, dann kannst du diese Daten ändern!
            </v-card-text>
            <v-card-text v-else-if="actionObject" class="px-6">
                <div>Bitte gib die Daten der aktuellen Dokumente für Mitglied
                    <span class="font-weight-bold primary--text">{{actionObject.spieler.vorname}}
                {{actionObject.spieler.nachname}}</span>
                    (Pass-Nr. <span class="font-weight-bold">{{actionObject.spieler.passNr}}</span>)
                    ein:
                </div>
                <div class="mt-6 px-3">
                    <v-row v-if="fieldList" >
                        <v-col v-for="(field, i) in fieldList" :key="i" cols="12" class="px-0 py-0">
                            <v-text-field v-if="field.type==='date' && !field.optional"
                                          type="date"
                                          v-model="spieler[field.id]"
                                          :label="field.app" :rules="getRules(field)">
                            </v-text-field>
                            <input-date-optional v-else :field="field" :data-object="spieler"
                                                 @dateError="setDateError">
                            </input-date-optional>
                        </v-col>
                    </v-row>
                </div>
            </v-card-text>
        </form-container>
    </div>

</template>

<script>
    import FormContainer from "../../../components/form/formContainer";
    import InputDateOptional from "../../../components/form/inputDateOptional";
    import TimeStamp from "../../../services/timeStamp";
    import {FormRules} from "../../../services/formRules";
    import SPIELER_CHANGE_HANDLER from "../../../services/data/spieler/spielerChangeHandler";

    export default {
        components: { FormContainer, InputDateOptional },
        name: "spieler-bestaetigungen",
        props: ['spieler', 'item', 'action', 'actionObject'],
        data: () => ({
            dateError: false,
            rules: null,
            currentData: null,
        }),
        computed: {
            fieldList() { return this.spieler ? this.spieler.getFieldListEdit('bestaetigungen'): [] },
            pendingBestaetigungen() { return this.$store.state.realtime.pendingActions.find(
                    pendingBestaetigung => pendingBestaetigung.search_spieler === this.spieler.id &&
                    pendingBestaetigung.actionType === 'bestaetigungen'); },
        },
        created(){
            this.rules = new FormRules();
        },
        methods: {
            // no limit for pending changes, can be multiple per player
            // show all to passreferent, sequence of row processing counts!!!
            async save(){
                if ( this.dateError ) { return; }
            // check: has something changed and create an array of all data (field + value)
                //let currentData = this.$store.getters.getFromAnyRealtimeListById(['vereinsspieler', 'spielerSearchResult'], this.spieler.id);
                this.actionObject.clearChanges();
                this.fieldList.forEach( (field) => {
                    if ( this.spieler[field.id] !== this.currentData[field.id]) {
                    // log changes in actionObject
                        this.actionObject.changes.push(
                            {field: field.id, valueOld: this.currentData[field.id], valueNew: this.spieler[field.id]});
                    // log changed fields for the update of the spieler object
                        this.spieler.local.documentUpdates[field.id] = this.spieler[field.id];
                    }
                });
            // cancel if no changes
                if ( this.actionObject.changes.length === 0 ) {
                    this.$emit('actionSnack', {text: 'Du hast keine Daten geändert!', color: 'error'});
                    window.history.back();
                    return;
                }
            // update search.docs
                let searchTemp = JSON.parse(JSON.stringify(this.spieler.search));
                searchTemp = SPIELER_CHANGE_HANDLER.search_setBestaetigungenStatus( searchTemp,
                                this.spieler.ade, this.spieler.dsv, this.spieler.status );
                this.spieler.local.documentUpdates['search.docs'] = searchTemp.docs;
            // start

                this.$store.state.local.loader = true;
                this.actionObject.setSpielerTemp(this.spieler);
            // send
                this.spieler.local.documentUpdates.letzteAenderung = TimeStamp.getGMTTimestamp();
                this.actionObject.setTimeStamp();
                if ( this.pendingBestaetigungen ) {
                    console.log ("this.pendingBestaetigungen", this.pendingBestaetigungen);
                    this.actionObject.refreshChanges(this.pendingBestaetigungen.changes);
                    this.actionObject.local.documentUpdates = {
                        changes: this.actionObject.changes,
                        createdAt: this.actionObject.createdAt,
                        createdByName: this.actionObject.createdByName,
                        createdBy: this.actionObject.createdBy,
                    };
                    this.actionObject.setId (this.pendingBestaetigungen.id);
                }
                this.actionObject.autoConfirmDuplicateAndContentChanges()
                let replyAction = this.pendingBestaetigungen ?
                    await this.actionObject.saveEdited('spielerActions_bestaetigungen') :
                    await this.actionObject.saveNew('document');
                let replySpieler = await this.spieler.updateWithTransaction('spielerBestaetigungen', false);
                if ( replyAction.successful && replySpieler.successful ) {
                    this.$emit('actionSnack', {text: 'Die Änderung der Bestätigungsdaten war erfolgreich!', color: 'success'});
                    this.$store.state.local.loader = false;
                    window.history.back();
                } else {
                    // error handling
                }
            },
            setDateError(dateError){
                this.dateError = dateError;
            },
            getRules(field){
                let ruleList = [];
                if ( field.optional === undefined ) {
                    if ( field.type === 'date' ) {
                        ruleList.push(this.rules.requiredDate)
                    } else if (field.id === 'plz') {
                        ruleList.push(this.rules.zipCode);
                        ruleList.push(this.rules.required);
                    } else {
                        ruleList.push(this.rules.required)
                    }
                }
                if ( field.type === 'string' ) {
                    ruleList.push(this.rules.string)
                }
                if ( field.notInFuture ) {
                    ruleList.push(this.rules.notInFuture)
                }
                return ruleList;
            },
        },
        watch: {
            spieler(to){
                this.currentData = JSON.parse(JSON.stringify(to))
            }
        }
    }
</script>

<style scoped>

</style>